import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'
// import store from '../store/index'
Vue.use(VueRouter)

const constantRoutes = [
  {
    path: '/',
    name: 'index',
    component: index,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: '/index',
        component: resolve => require(['../views/index/index.vue'], resolve),
        meta: { requireAuth: true },
      }]
  },
  {
    path: '/details',
    name: '/details',
    component: resolve => require(['../views/details/index.vue'], resolve),
    meta: { requireAuth: true },
  },
  {
    path: '/user',
    name: '/user',
    component: resolve => require(['../views/user/index.vue'], resolve),
    meta: { requireAuth: true },
  },
  {
    path: '/list',
    name: '/list',
    component: resolve => require(['../views/details/list.vue'], resolve),
    meta: { requireAuth: true },
  },
  {
    path: '/notice',
    name: '/notice',
    component: resolve => require(['../views/user/list.vue'], resolve),
    meta: { requireAuth: true },
  },
  {
    path: '/customer-dppm',
    name: '/customer-dppm',
    component: resolve => require(['../views/charts/customerDppmPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/customer-fpy',
    name: '/customer-fpy',
    component: resolve => require(['../views/charts/customerPassRatioPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/failure',
    name: '/failure',
    component: resolve => require(['../views/charts/failureTimesPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/appearance-dppm',
    name: '/appearance-dppm',
    component: resolve => require(['../views/charts/appearanceDppmPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/function-dppm',
    name: '/function-dppm',
    component: resolve => require(['../views/charts/functionDppmPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/lar',
    name: '/lar',
    component: resolve => require(['../views/charts/larChartPage.vue'], resolve),
    meta: { requireAuth: false },
  },
  {
    path: '/loss-rate',
    name: '/loss-rate',
    component: resolve => require(['../views/charts/damageRatioChartPage.vue'], resolve),
    meta: { requireAuth: false },
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

//在VUE中路由遇到Error: Avoided redundant navigation to current location
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router
